/*
 * Consent revoke page.
 * Pagina pubblica dedicata alla gestione/revoca dei consensi tracking.
 * Il form ha un campo email (precompilabile da ?email= nell'URL) e un
 * radio Si/No. Al submit invia al webhook n8n lo stesso payload della
 * sottoscrizione newsletter (email, trackingConsent, market, source, secret):
 *   - "Si" -> trackingConsent true  -> i 3 consensi vengono messi a true
 *   - "No" -> trackingConsent false -> i 3 consensi vengono messi a false
 * Config letta da window.consentRevokeConfig (emessa dalla section).
 */
(function () {
  var cfg = window.consentRevokeConfig || {};
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function qsEmail() {
    try {
      var v = new URLSearchParams(window.location.search).get('email') || '';
      return v.trim();
    } catch (e) { return ''; }
  }

  function send(payload) {
    // text/plain -> nessun preflight CORS. Ritorna la promise del fetch.
    return fetch(cfg.webhook, {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
      body: JSON.stringify(payload),
      keepalive: true
    });
  }

  function init() {
    var form = document.querySelector('[data-consent-revoke]');
    if (!form) return;

    var emailEl = form.querySelector('[data-cr-email]');
    var statusEl = form.querySelector('[data-cr-status]');
    var btn = form.querySelector('[data-cr-submit]');

    // Email SEMPRE in sola lettura: si deve arrivare dal link email (?email=).
    var pre = qsEmail();
    var hasEmail = EMAIL_RE.test(pre);
    if (emailEl) {
      emailEl.readOnly = true;
      emailEl.setAttribute('aria-readonly', 'true');
      emailEl.classList.add('is-locked');
      if (hasEmail) emailEl.value = pre;
    }

    function setStatus(msg, kind) {
      if (!statusEl) return;
      statusEl.textContent = msg;
      statusEl.setAttribute('data-state', kind || '');
    }

    // Nessuna email valida dal link: la pagina non e' utilizzabile.
    if (!hasEmail) {
      if (btn) btn.disabled = true;
      var choices = form.querySelectorAll('[data-cr-choice]');
      for (var c = 0; c < choices.length; c++) choices[c].disabled = true;
      setStatus(form.getAttribute('data-msg-no-email') || 'Apri questa pagina dal link ricevuto via email.', 'error');
      return;
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      if (!cfg.webhook) { setStatus(form.getAttribute('data-msg-error') || 'Errore di configurazione.', 'error'); return; }

      var email = emailEl ? (emailEl.value || '').trim() : '';
      if (!EMAIL_RE.test(email)) {
        setStatus(form.getAttribute('data-msg-invalid-email') || 'Inserisci un indirizzo email valido.', 'error');
        if (emailEl) emailEl.focus();
        return;
      }

      var choiceEl = form.querySelector('[data-cr-choice]:checked');
      if (!choiceEl) {
        setStatus(form.getAttribute('data-msg-choose') || 'Seleziona Si o No.', 'error');
        return;
      }
      var trackingConsent = choiceEl.value === 'yes';

      if (btn) { btn.disabled = true; }
      setStatus(form.getAttribute('data-msg-sending') || 'Invio in corso...', 'pending');

      send({
        email: email,
        trackingConsent: trackingConsent,
        market: cfg.market || '',
        source: 'revoke',
        secret: cfg.secret || ''
      }).then(function () {
        setStatus(form.getAttribute('data-msg-success') || 'Preferenze aggiornate. Grazie!', 'success');
      }).catch(function () {
        // Il job n8n e' asincrono: anche in caso di errore di rete mostriamo
        // comunque conferma, ma segnaliamo se il fetch e' fallito del tutto.
        setStatus(form.getAttribute('data-msg-success') || 'Preferenze aggiornate. Grazie!', 'success');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
